import { useContext } from 'react';

import { FormIssue } from './components';

import { ConfirmIssueQuotation, QuotationInfoContext } from '../../../shared';
import { ConfirmIssueRenewal } from '../../../shared/components/ConfirmIssueRenewal';

export const StepFive = () => {
  const { canShowConfirmIssue, canShowConfirmRenewal } = useContext(QuotationInfoContext);

  if (canShowConfirmIssue) {
    return <ConfirmIssueQuotation />;
  }

  if (canShowConfirmRenewal) {
    return <ConfirmIssueRenewal />;
  }

  return <FormIssue />;
};
